module.exports = __webpack_public_path__ + "static/media/beatos_venezolanos-319.114ec21f.jpg";